import React, { Component } from "react";

class TermsOfService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scriptLoaded: false,
    };
  }
  componentDidMount() {
    // Create a script element
    console.log("Cookie policy doc");
    const script = document.createElement("script");
    script.id = "termly-jssdk";
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      this.setState({ scriptLoaded: true });
    };

    // Append the script to the document body
    document.body.appendChild(script);
  }

  render() {
    if (!this.state.scriptLoaded) {
      return <p>Loading Terms and Service...</p>;
    }
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
        }}
      >
        {/* Termly Embed Placeholder */}
        <div name="termly-embed" data-id="bb8b6a76-aa10-4db4-9fdf-6c1e4c619e5b"
          style={{
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            padding: "35px",
            zIndex: 1000,
            width: "70vw"

          }}

        ></div>
      </div>
    );
  }
}

export default TermsOfService;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/TermsOfService.js